function underZipLimit(input, limit) {
  return input.split(',').reduce((acc, item) => {
    let retItem = item.replace(/\s/g,'');
    if (retItem) {
      acc.push(retItem);
    }
    return acc;
  },[]).length <= limit;
}

function validateZipCodes(input, zipTypes) {
  
  const regexZipOpts = {
    "zip": "(^[0-9]{5}$)",
    "zip3": "(^[0-9]{3}$)",
    "zip+4": "(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
  };
  
  const completeRegex = new RegExp(`${zipTypes.map(zipType => regexZipOpts[zipType]).join('|')}`);
  
  let isValid = true;
  const splitInput = input.split(',');
  
  for (let i = 0; i < splitInput.length; i++) {
    let inputSegment = splitInput[i];
    inputSegment = inputSegment.trim().replace(/\s/g,'');
    if (inputSegment === '') {//tolerate empty strings
      continue;
    }
    if (
      !inputSegment ||
      !(completeRegex.test(inputSegment))
    ) {
      isValid = false;
      break;
    }
  }
  return isValid;
}

export {
    underZipLimit,
    validateZipCodes
};